/* eslint-disable react/jsx-pascal-case */
import PropTypes from 'prop-types';
import {useTranslations} from 'next-intl';
import Link from '@/links';
import {withBoldWeight} from '@/hocs/withFontType';
import {PMarginTMd} from '@/typography';
import {Table, TBody, TR, TH, TD} from '@/ui/tables';

const BoldSpan = withBoldWeight('span');

const propTypes = {
  className: PropTypes.string.isRequired,
  sectionTitle: PropTypes.string.isRequired,
  sectionDescription: PropTypes.string.isRequired,
  cookiesTable: PropTypes.arrayOf(
    PropTypes.shape({
      vendor: PropTypes.string.isRequired,
      vendorURL: PropTypes.string.isRequired,
      cookies: PropTypes.string.isRequired
    })
  ).isRequired
};

const CookiesTable = ({className, sectionTitle, sectionDescription, cookiesTable}) => {
  const t = useTranslations('cookiesList.tableHeaders');

  return (
    <div>
      <BoldSpan>{sectionTitle}</BoldSpan>
      <PMarginTMd>{sectionDescription}</PMarginTMd>
      <Table className={className}>
        <TBody>
          <TR>
            <TH className="w-20">
              <BoldSpan>{t('provider')}</BoldSpan>
            </TH>
            <TH className="w-80">
              <BoldSpan>{t('cookies')}</BoldSpan>
            </TH>
          </TR>

          {cookiesTable.map((item, index) => (
            // eslint-disable-next-line react/no-array-index-key
            <TR key={index}>
              <TD>
                {item.vendorURL ? (
                  <Link href={item.vendorURL} target="_blank" variant="default">
                    {item.vendor}
                  </Link>
                ) : (
                  item.vendor
                )}
              </TD>
              <TD>{item.cookies}</TD>
            </TR>
          ))}
        </TBody>
      </Table>
    </div>
  );
};

CookiesTable.propTypes = propTypes;

export default CookiesTable;
